import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Botón pill con micro-interacción
export const CTA = ({
  to,
  href,
  children,
  variant = "coral",
  className = "",
  icon = true,
  ...rest
}) => {
  const variants = {
    coral: "bg-coral text-white hover:bg-[#ff9d94]",
    ink: "bg-ink text-cream hover:bg-black",
    mint: "bg-mint text-ink hover:bg-[#bdeeda]",
    outline: "bg-transparent text-ink ring-2 ring-ink/15 hover:ring-ink/40",
  };
  const cls = `group inline-flex items-center gap-2 rounded-full px-7 py-3.5 font-semibold text-sm sm:text-base transition-all duration-300 hover:-translate-y-0.5 active:translate-y-0 ${variants[variant]} ${className}`;
  const inner = (
    <>
      {children}
      {icon && (
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
      )}
    </>
  );
  if (to)
    return (
      <Link to={to} className={cls} {...rest}>
        {inner}
      </Link>
    );
  return (
    <a href={href || "#"} className={cls} {...rest}>
      {inner}
    </a>
  );
};

export const Eyebrow = ({ children, color = "#FF8A80", className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] ${className}`}
    style={{ color }}
  >
    <span
      className="h-1.5 w-1.5 rounded-full"
      style={{ backgroundColor: color }}
    />
    {children}
  </span>
);

export const Section = ({ children, className = "", alt = false, id }) => (
  <section
    id={id}
    className={`px-5 sm:px-8 lg:px-12 py-20 sm:py-28 ${
      alt ? "bg-mist" : "bg-cream"
    } ${className}`}
  >
    <div className="mx-auto max-w-7xl">{children}</div>
  </section>
);
